import { GridActionsCellItem, GridDeleteIcon, GridRowParams, GridViewColumnIcon } from "@mui/x-data-grid"
import { useContext } from "react"
import { Button, Grid, Input, Layout, Loader, LoaderContainer, Modal, Paper, Table } from "../../components"
import { AuthContext } from "../../contexts"
import DownloadIcon from '@mui/icons-material/Download';
import { useAPI, useToggle } from "../../hooks";
import { enqueueSnackbar } from "notistack";
import { formatDateTime } from "@bussola-viagens/utils";
import { Navigate, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import VisibilityIcon from '@mui/icons-material/Visibility';
import { CreateTrainingSchema } from "@bussola-viagens/validations";

export const MyTrainingsPage = () => {
    const navigate = useNavigate()
    const [trainings] = useAPI(`/training`)
    
    const { me } = useContext(AuthContext)

    if (!me?.group.group_module?.is_training_enabled) {
        return (
            <Navigate to="/home" />
        )
    }

    if (trainings.loading) {
        return (
            <LoaderContainer>
                <Loader />
            </LoaderContainer>
        )
    }

    return (
        <Layout>
            <Grid container p={1} justifyContent="center" spacing={1}>
                <Grid item xs={10}>
                    <Paper>
                        <Table 
                            columns={[
                                { field: 'created_at', flex: 1, type: 'dateTime', headerName: 'Data de Criação', valueGetter: (value) => new Date(value), valueFormatter: formatDateTime },
                                { field: 'name', flex: 1, type: 'string', headerName: 'Nome' },
                                { field: 'lessons', flex: 1, type: 'number', headerName: 'Aulas', valueGetter: (value: Array<string>) => value.length },
                                { field: 'actions', type: 'actions', getActions: (params: GridRowParams) => [
                                    <GridActionsCellItem 
                                        icon={<VisibilityIcon />} 
                                        onClick={() => {
                                            navigate(`/meus-treinamentos/${params.id}`)
                                        }} 
                                        label="Ver Detalhes" 
                                    />,
                                ] }
                            ]}
                            rows={trainings.data || []}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </Layout>
    )
}